module.exports = __webpack_public_path__ + "static/media/top-gummy.93481f19.png";